 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0008 from '@/components/content/content0008'
 import CONTENTCONTENT0009 from '@/components/content/content0009'
 import CONTENTCONTENT0010 from '@/components/content/content0010'
 import CONTENTCONTENT0014 from '@/components/content/content0014'
 import CONTENTCONTENT0019 from '@/components/content/content0019'
 import CONTENTCONTENT0032 from '@/components/content/content0032'
 import CONTENTCONTENT0038 from '@/components/content/content0038'
 import CONTENTCONTENT0043 from '@/components/content/content0043'
 import CONTENTCONTENT0051 from '@/components/content/content0051'
 import CONTENTCONTENT0070 from '@/components/content/content0070'
 import CONTENTCONTENT0084 from '@/components/content/content0084'
 import CONTENTCONTENT0089 from '@/components/content/content0089'
 import CONTENTCONTENT0094 from '@/components/content/content0094'
 import CONTENTCONTENT0106 from '@/components/content/content0106'
 import CONTENTCONTENT0112 from '@/components/content/content0112'
 import CONTENTCONTENT0120 from '@/components/content/content0120'
 import CONTENTCONTENT0123 from '@/components/content/content0123'
 import CONTENTCONTENT0129 from '@/components/content/content0129'
 import CONTENTCONTENT0143 from '@/components/content/content0143'
 import CONTENTCONTENT0152 from '@/components/content/content0152'
 import CONTENTCONTENT0169 from '@/components/content/content0169'
 import CONTENTCONTENT0176 from '@/components/content/content0176'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0008",
 			"name" : "content/content0008",
 			"component" : CONTENTCONTENT0008
 		},
 		{
 			"path" : "/content/content0009",
 			"name" : "content/content0009",
 			"component" : CONTENTCONTENT0009
 		},
 		{
 			"path" : "/content/content0010",
 			"name" : "content/content0010",
 			"component" : CONTENTCONTENT0010
 		},
 		{
 			"path" : "/content/content0014",
 			"name" : "content/content0014",
 			"component" : CONTENTCONTENT0014
 		},
 		{
 			"path" : "/content/content0019",
 			"name" : "content/content0019",
 			"component" : CONTENTCONTENT0019
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js